import { Component, OnInit } from '@angular/core'
import { DestroyService } from '@core/services/destroy.service'
import { NetworkStatus } from '@shared/models/network-status.model'
import { NetworkStatusService } from '@core/services/network-status.service'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'lin-network-status',
  templateUrl: './network-status.component.html',
  styleUrls: ['./network-status.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class NetworkStatusComponent implements OnInit {
  status: NetworkStatus
  NetworkStatus = NetworkStatus

  constructor(
    private readonly networkStatusService: NetworkStatusService,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    const statusSubscribe = (status: NetworkStatus): void => {
      this.status = status
    }

    this.networkStatusService.status$.pipe(takeUntil(this.destroyService)).subscribe(statusSubscribe)
  }
}
